import { DataTableColumn } from '../../Base/Components/DataTable/DataTable';
import { MedicalProceduresQuery } from '../../../graphql/graphql';
import React from 'react';
import { QueryDataItem } from '../../../Interfaces/QueryDataItem';
import ManagerInsuranceCompaniesCaseTypesImportCheckbox from '../Components/ManagerWrapper/InsuranceCompanies/ManagerInsuranceCompaniesCaseTypesImport/ManagerInsuranceCompaniesCaseTypesImportCheckbox';

export type MedicalProcedureImport = QueryDataItem<
	MedicalProceduresQuery['medicalProcedures']
> & {
	imported: boolean;
};

export interface MedicalProceduresImportTable {
	selectedIds: Set<string>;
	toggleSelectedId: (id: string, value: boolean) => void;
}

export const MedicalProceduresImportDefaultColumns: DataTableColumn<
	MedicalProcedureImport,
	MedicalProceduresImportTable
>[] = [
	{
		key: 'code',
		label: 'component.caseType.tableCode',
		bold: true,
		renderItem: (item: MedicalProcedureImport) => (
			<span>{item?.code || ''}</span>
		),
	},
	{
		key: 'name',
		label: 'component.caseType.tableName',
		renderItem: (item: MedicalProcedureImport) => (
			<span>{item?.name || ''}</span>
		),
	},
	{
		key: 'mainFieldOfCare',
		label: 'component.caseType.tableMainFieldOfCare',
		renderItem: (item: MedicalProcedureImport) => (
			<span>{item?.mainFieldOfCare || ''}</span>
		),
	},
	{
		key: 'sharedFieldOfCare',
		label: 'component.caseType.tableSharedFieldOfCare',
		renderItem: (item: MedicalProcedureImport) => {
			const fieldOfCares = item.sharedFieldOfCare ?? [];
			return <span>{fieldOfCares.join(', ')}</span>;
		},
	},
	{
		key: 'checkbox',
		label: 'component.caseType.importTableCheckbox',
		renderItem: (
			item: MedicalProcedureImport,
			{ selectedIds, toggleSelectedId }: MedicalProceduresImportTable,
		) => {
			return (
				<ManagerInsuranceCompaniesCaseTypesImportCheckbox
					item={item}
					selectedIds={selectedIds}
					toggleSelectedId={toggleSelectedId}
				/>
			);
		},
	},
];
